<template>
  <div>
    <div class="columns is-multiline is-align-items-end">
      <div class="column is-3">
        <b-field label="Filtrar por rango de fechas" class="range-filter">
          <b-datepicker
            placeholder="Selecciona un rango de fechas"
            v-model="dates"
            range
            :max-date="maxDate"
            :mobile-native="false"
            :editable="true"
            @icon-right-click="dates = ''"
          >
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field label="Tipo de interacción" class="interaction-filter">
          <b-select placeholder="Selecciona un tipo de interacción" expanded clearable v-model="tipo_interaccion">
            <option :value="''" :key="''">TODAS</option>
            <option :value="'compra'" :key="'compra'">COMPRA</option>
            <option :value="'venta'" :key="'venta'">VENTA</option>
            <option :value="'business'" :key="'business'">GO BUSINESS</option>
            <option :value="'referencia'" :key="'referencia'">REFERENCIA</option>
            <option :value="'alianza'" :key="'alianza'">ALIANZA</option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-3">
        <b-field label="Estatus" class="status-filter">
          <b-select placeholder="Selecciona un estatus" expanded clearable v-model="estatus">
            <option :value="''" :key="''">TODOS</option>
            <option :value="'pendiente'" :key="'pendiente'">PENDIENTE</option>
            <option :value="'rechazada'" :key="'rechazada'">RECHAZADA</option>
            <option :value="'aceptada'" :key="'aceptada'">ACEPTADA</option>
            <option :value="'aclarar'" :key="'aclarar'">POR ACLARAR</option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-3">
        <b-field label="Círculo" class="circle-filter">
          <b-select placeholder="Selecciona un círculo" expanded clearable v-model="circulo_id">
            <option :value="''" :key="''">TODOS</option>
            <option v-for="circulo in circulosOptions" :key="circulo.id" :value="String(circulo.id)">
              {{ circulo.nombre }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-10">
        <b-field label="Buscar" class="search-filter">
          <b-input
            v-model="searchQuery"
            placeholder="Buscar..."
            type="search"
            icon-right-clickable
            expanded
            @icon-right-click="searchQuery = ''"
            @input="reloadSearch"
            @keydown.native.enter="loadAsyncData"
          />
        </b-field>
      </div>

      <div class="column is-2 is-narrow">
        <b-button @click="loadAsyncData" type="is-primary" expanded> Buscar </b-button>
      </div>
    </div>

    <!-- Tabla -->
    <b-table
      :data="data"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      :loading="loading"
      :per-page="perPage"
      :total="total"
      :mobile-cards="false"
      backend-pagination
      backend-sorting
      paginated
      @page-change="onPageChange"
      @sort="onSort"
      filters-change
      striped
    >
      <b-table-column field="creado" label="Interacción" sortable v-slot="props">
        <strong> Tipo: </strong>
        {{
          props.row.tipo_interaccion === 'compra'
            ? 'COMPRA'
            : props.row.tipo_interaccion === 'venta'
            ? 'VENTA'
            : props.row.tipo_interaccion === 'business'
            ? 'GO BUSINESS'
            : props.row.tipo_interaccion.toUpperCase()
        }}
        <br />
        <strong> Fecha: </strong> {{ formatDate(props.row.fecha_interaccion) }}
        <br />
        <strong> Creado: </strong> {{ formatDate(props.row.creado) }}
        <br />
        <p v-if="props.row.monto > 0"><strong> Monto: </strong> {{ formatMonto(props.row.monto) }}</p>
      </b-table-column>

      <b-table-column field="emisor_id" label="Emisor" sortable v-slot="props">
        <strong> Socio: </strong> {{ props.row.emisor_nombre + ' ' + props.row.emisor_apellido }} <br />
        <strong> RFC: </strong> {{ props.row.emisor_rfc }} <br />
        <strong> Empresa: </strong> {{ props.row.emisor_empresa }} <br />
        <strong v-if="props.row.emisor_circulo"> Círculo: </strong> {{ props.row.emisor_circulo }}
      </b-table-column>
      <b-table-column field="receptor_id" label="Receptor" sortable v-slot="props">
        <template v-if="props.row.receptor_nombre">
          <strong> Socio: </strong> {{ props.row.receptor_nombre + ' ' + props.row.receptor_apellido }} <br />
          <strong> RFC: </strong> {{ props.row.receptor_rfc }} <br />
          <strong> Empresa: </strong> {{ props.row.receptor_empresa }} <br />
          <strong v-if="props.row.receptor_circulo"> Círculo: </strong> {{ props.row.receptor_circulo }}
        </template>
        <template v-else-if="props.row.invitado_nombre">
          <strong> Invitado: </strong> {{ props.row.invitado_nombre + ' ' + props.row.invitado_apellido }} <br />
          <strong> RFC: </strong> {{ props.row.invitado_rfc }} <br />
          <strong> Empresa: </strong> {{ props.row.invitado_empresa }} <br />
          <strong> Giro: </strong> {{ props.row.invitado_giro }}
        </template>
        <template v-else> Sin información disponible </template>
      </b-table-column>

      <b-table-column field="estatus" label="Estatus" sortable v-slot="props">
        {{ props.row.estatus.toUpperCase() }}
      </b-table-column>

      <b-table-column field="id" label="Acciones" v-slot="props">
        <div class="buttons">
          <b-button @click="openModal(props.row)" type="is-info" icon-left="handshake" size="is-small" title="Interaccion"></b-button>
          <b-button @click="deleteRow(props.row.id)" type="is-danger" icon-left="delete" size="is-small" title="Eliminar"></b-button>
        </div>
      </b-table-column>
    </b-table>

    <div v-if="showFormModal" class="modal form-Interactions-modal" :class="{ 'is-active': showFormModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">Interacción</h2>
          <button @click="showFormModal = false" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <Form :key="formKey" :datavalues="formModalData" @close-form="closeForm"></Form>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end"></footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Form from './form.vue';
import Swal from 'sweetalert2';
import moment from 'moment';
import 'moment/locale/es';

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'admin',
    },
  },
  components: {
    Form,
  },
  data() {
    return {
      formKey: 0,
      data: [],
      total: 0,
      loading: false,
      sortField: 'id',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 20,
      searchQuery: '',
      showFormModal: false,
      formModalData: {},
      tipo_interaccion: '',
      estatus: '',
      circulo_id: '',
      dates: [],
      maxDate: moment().toDate(),
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.loadAsyncData();
  },
  computed: {
    ...mapState({
      interactions: (state) => state.interactions.list,
      pagination: (state) => state.interactions.pagination,
      reload: (state) => state.interactions.reloadList,
      options: (state) => state.interactions.options,
    }),
    circulosOptions() {
      if (!this.options || !Array.isArray(this.options.circulos)) {
        return [];
      }
      return this.options.circulos;
    },
  },
  watch: {
    async reload(newValue) {
      if (newValue) {
        await this.loadAsyncData();
      }
    },
    async tipo_interaccion() {
      this.page = 1;
      await this.loadAsyncData();
    },
    async estatus() {
      this.page = 1;
      await this.loadAsyncData();
    },
    async circulo_id() {
      this.page = 1;
      await this.loadAsyncData();
    },
    dates: {
      async handler() {
        this.page = 1;
        await this.loadAsyncData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      fetchList: 'interactions/fetchList',
      remove: 'interactions/remove',
    }),
    async loadAsyncData() {
      this.loading = true;

      let formattedDates = [];
      if (this.dates && this.dates.length > 0) {
        formattedDates = this.dates.map((date) => moment(date).format('YYYY-MM-DD'));
      }

      const params = {
        page: this.page,
        size: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        search: this.searchQuery.trim().toLowerCase(),
        tipo_interaccion: this.tipo_interaccion || '',
        estatus: this.estatus || '',
        circulo_id: this.circulo_id || '',
        dates: formattedDates,
      };

      await this.fetchList(params);

      this.data = this.interactions;
      this.total = this.pagination.total;

      this.loading = false;
      this.$store.commit('interactions/SET_DATA', { key: 'reloadList', data: false });
    },
    async onPageChange(page) {
      this.page = page;
      await this.loadAsyncData();
    },
    async onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      await this.loadAsyncData();
    },
    async reloadSearch() {
      if (this.searchQuery.length == 0) {
        this.page = 1;
        await this.loadAsyncData();
      }
    },
    openModal(data) {
      this.formKey++;
      this.showFormModal = true;

      const params = {
        formType: this.type,
        ...data,
      };

      this.formModalData = params;
    },
    closeForm() {
      this.showFormModal = false;
    },
    async deleteRow(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'No podrás recuperar este registro después de eliminarlo.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, borrar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        const response = await this.remove(id);

        Swal.fire({
          icon: response.status ? 'success' : 'error',
          title: response.message,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
        });

        await this.loadAsyncData();
      }
    },
    formatDate(date) {
      if (!date) return 'Sin fecha';
      const formatted = moment(date).format('dddd, D [de] MMMM [de] YYYY, h:mm A');
      return formatted.charAt(0).toUpperCase() + formatted.slice(1); // Mayúscula inicial
    },
    formatMonto(monto) {
      return (
        new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
          currencyDisplay: 'symbol', // Muestra el símbolo del peso ($)
        })
          .format(monto)
          .replace('MX$', '') + ' MXN'
      );
    },
  },
};
</script>

<style>
@media screen and (max-width: 1023px) {
  .range-filter {
    margin-top: 100px;
  }
}
</style>
